var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container"},[_c('div',{ref:"googleMap",staticClass:"map",on:{"click":function () {
                _vm.$emit('click');
            }}})])}
var staticRenderFns = []

export { render, staticRenderFns }